export default "__VITE_ASSET__eb866d5e__"